import { render, staticRenderFns } from "./DataRecordsExtendedRow.vue?vue&type=template&id=3b982436&scoped=true&"
import script from "./DataRecordsExtendedRow.vue?vue&type=script&lang=js&"
export * from "./DataRecordsExtendedRow.vue?vue&type=script&lang=js&"
import style0 from "./DataRecordsExtendedRow.vue?vue&type=style&index=0&id=3b982436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b982436",
  null
  
)

export default component.exports